import {AjaxController} from "./ajax-controller";

window.AjaxController = AjaxController;

export class AjaxForm {
    constructor(formElement, options, successCb) {
        let that = this;
        that.$form = $(formElement)

        // Options
        options = $.extend(true, options || {}, {
            method: that.$form.attr("method"),
            actions: {
                "hideForm": () => {
                    that.$form.find(".af-form-container").hide();
                }
            }
        })

        // Ajax
        that.ajax = new AjaxController(that.$form.attr("action"), that.$form, options)

        // Success
        that.successCb = successCb
    }


    static init(options) {
        $("body").on("submit", "[data-af-ajax-form]", function (e) {
            (new AjaxForm(this, options)).submit(e);
        }).on("click", ".on-click-submit", function (e) {
            e.preventDefault();
            $(this).closest("form").trigger("submit");
        }).on("click", "[data-ajax-btn]", function (e) {
            e.preventDefault();
            let $this = $(this),
                controller = new AjaxController($this.data("ajaxBtn"), $this, {
                    "method": "post"
                });
            $this.hasClass("tooltipstered") && $this.tooltipster("hide")
            controller.submit($this.data("ajaxBtnData"));
        });
    }


    submit(e) {
        // Prevent regular submit
        e.preventDefault();

        // Define vars
        const obj = this,
            $form = obj.$form,
            formData = new FormData(e.target);

        // Remove all errors
        $form.find(".af-field-error, .alert").fadeOut(0).html("");
        $form.find(".af-field-has-error").removeClass("af-field-has-error");

        // Submit the ajax form
        const promise = obj.ajax.submit(formData);
        promise.then((data) => {
            obj.success(JSON.parse(data));
        }).done(() => {
            $form.find(".af-field-submit-disabled").attr("disabled", false).removeClass("af-field-submit-disabled");
        });

        // Disable all fields
        $form.find("input, select, textarea, button").each(function () {
            if (!$(this).attr("disabled")) {
                $(this).attr("disabled", true).addClass("af-field-submit-disabled");
            }
        })
    }


    success(data) {
        if (data.fieldErrors) {
            var errorCounter = 0;

            // Add fielderror-placeholder
            this.$form.find(".af-field").each(function () {
                if (!$(this).find(".af-field-error").length) {
                    $(this).append("<div class='af-field-error'></div>");
                }
            });

            // loop over field errors
            for (var field in data.fieldErrors) {
                var error = data.fieldErrors[field];

                if (Array.isArray(error)) {
                    this.fieldError(field, error.join("<br>"), errorCounter++ == 0);
                } else if (typeof error === 'object') {
                    for (var subfield in error) {
                        this.fieldError(field + "__" + subfield, error[subfield], errorCounter++ == 0);
                    }
                } else {
                    this.fieldError(field, error, errorCounter++ == 0);
                }
            }
        }

        // trigger event
        this.$form.trigger("af-success", data);

        // Extra success callback
        if (typeof this.successCb === 'function') {
            this.successCb(data);
        }
    }


    fieldError(name, msg, scrollTo) {
        var $field = this.$form.find(".af-field-" + name),
            $error = $field.find(".af-field-error");
        $field.addClass("af-field-has-error");
        $error.html(msg).fadeIn(500);
        scrollTo && this.ajax.scrollTo($field);
        this.shake($field);
    }


    shake($el) {
        $el.addClass('shake');
        setTimeout(function () {
            $el.removeClass('shake');
        }, 950);
    }
}
